import React from "react";
import { Box, Typography } from "@mui/material";

import { SubscriptionUsageType } from "fond/api/accountSlice";
import { Usage } from "fond/types";

import PremsUsageChart from "../InsightsChart/PremsUsageChart";

import { CardHeader } from "./insightsOverview.styles";

interface InsightsOverviewProps {
  subscriptionUsage?: Usage;
  usageType?: SubscriptionUsageType;
  showHeader?: boolean;
}
const InsightsOverview: React.FC<InsightsOverviewProps> = ({
  subscriptionUsage,
  usageType = "planner",
  showHeader = true,
}: InsightsOverviewProps) => {
  return (
    <Box>
      {showHeader && (
        <CardHeader>
          <Typography variant="body1" fontWeight={500}>
            Overview
          </Typography>
        </CardHeader>
      )}
      <PremsUsageChart subscriptionUsage={subscriptionUsage} usageType={usageType} />
    </Box>
  );
};

export default InsightsOverview;
